import React from 'react';
// import './UserIndicator.css';

function UserIndicator({ user }) {
  if (!user) return null;
  const fullName = `${user.first_name} ${user.middle_name || ''} ${user.last_name}`.trim();

  return (
    <div className="user-indicator-bubble" title={fullName}>
      {fullName}
    </div>
  );
}


export default UserIndicator;
